export const TOGGLE_LOADING = 'moodle/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'moodle/TOGGLE_SUCCESS'
export const GET_MOODLE = 'moodle/GET_MOODLE'
export const SET_MOODLE = 'moodle/SET_MOODLE'
export const CREATE_MOODLE = 'moodle/CREATE_MOODLE'
export const EDIT_MOODLE = 'moodle/EDIT_MOODLE'
export const DELETE_MOODLE = 'moodle/DELETE_MOODLE'
export const SET_ERROR = 'moodle/SET_ERROR'
export const SET_PERMISSIONS = 'moodle/SET_PERMISSIONS'
